
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6.999","cy":"3.366","r":"1.121","transform":"rotate(90 7 3.366)","fill":"#999"}}),_c('circle',{attrs:{"cx":"6.999","cy":"6.999","r":"1.121","transform":"rotate(90 7 6.999)","fill":"#999"}}),_c('circle',{attrs:{"cx":"6.999","cy":"10.631","r":"1.121","transform":"rotate(90 7 10.63)","fill":"#999"}})])
          )
        }
      }
    